import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../../../i18n/useLanguage";
import { MandatoryLineItem } from "../../../../../stores/slices/cartSlice";
import { KeyValue } from "../../../../../ui/KeyValue/KeyValue";
import { PriceDisplay } from "../../../../../ui/PriceDisplay/PriceDisplay";
import { LineItemName } from "./LineItemName";

type MandatoryProps = {
  item: MandatoryLineItem;
};

export const MandatoryItem: FunctionComponent<MandatoryProps> = ({ item }) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  return (
    <div className="grid grid-cols-4 border px-4 py-2 lg:py-3 rounded-section">
      <strong className="font-medium col-span-3 md:col-span-1">
        <LineItemName item={item} language={language} />
      </strong>
      <KeyValue className="hidden md:block">
        <>{t("cart.price")}:</>
        <PriceDisplay>{Number(item.price) / Number(item.qty)}</PriceDisplay>
      </KeyValue>
      <KeyValue className="hidden md:block">
        <>{t("cart.quantity")}:</>
        <>{item.qty}</>
      </KeyValue>
      <KeyValue keyClassName="hidden md:block">
        <>{t("cart.totalPrice")}:</>
        <PriceDisplay>{item.price}</PriceDisplay>
      </KeyValue>
    </div>
  );
};
